import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
    selector: 'app-skeleton-emp-residence-history',
    templateUrl: './skeleton-emp-residence-history.component.html',
    styleUrls: ['./skeleton-emp-residence-history.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      NgxSkeletonLoaderModule
    ]
})
export class SkeletonEmpResidenceHistoryComponent implements OnInit {
  @Input() isResidenceHistory: boolean;
  constructor() {}

  ngOnInit(): void {}
}
